import { module } from "angular";
import { SearchComponent } from "./SearchComponent";

module("mmGui").component("mmSearch", new SearchComponent());
